const breakpoints = [800, 1600].map(bp => `${bp}px`)

export default breakpoints
